import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isCancelledError, useQueryClient } from '@tanstack/react-query';
import { useIsMounted } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { relationshipModel } from '~/models';
import { opportunityDestination } from '../utils/opportunityDestination';
const RESOLVE_PAYMENT_METHOD = true;
export const useOpportunityAction = (param)=>{
    let { opportunity, feedId } = param;
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { api } = useStoreActions();
    const isMounted = useIsMounted();
    const [outcome, setOutcome] = useState({
        feedId,
        state: 'idle'
    });
    const state = outcome.feedId === feedId ? outcome.state : 'idle';
    const checkAgreement = useCallback(async (relationshipId)=>{
        try {
            const relationship = await queryClient.fetchQuery({
                queryKey: [
                    QueryKeys.Relationship,
                    relationshipId,
                    RESOLVE_PAYMENT_METHOD
                ],
                staleTime: 0,
                queryFn: ()=>api.relationship.get(relationshipId, {
                        resolvePaymentMethod: RESOLVE_PAYMENT_METHOD
                    })
            });
            return relationshipModel.isEditable(relationship) ? 'open' : 'unreachable';
        } catch (error) {
            return isCancelledError(error) ? 'abandoned' : 'open';
        }
    }, [
        queryClient
    ]);
    const activate = useCallback(async ()=>{
        const destination = opportunityDestination(opportunity);
        if (destination.scope === 'client') {
            navigate(routes.client(destination.clientId));
            return;
        }
        setOutcome({
            feedId,
            state: 'checking'
        });
        const check = await checkAgreement(destination.relationshipId);
        if (!isMounted()) return;
        setOutcome({
            feedId,
            state: check === 'unreachable' ? 'unreachable' : 'idle'
        });
        if (check === 'open') navigate(routes.editAgreement(destination.relationshipId));
    }, [
        feedId,
        opportunity,
        checkAgreement
    ]);
    return {
        activate,
        isChecking: state === 'checking',
        isUnreachable: state === 'unreachable'
    };
};
